
import './lib/i18n';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './rd.css';
import { getSiteTheme } from './lib/settings';

// Na adrese tématu (/pejsci …) posílat téma ke každému volání vlastního API, aby server věděl,
// do které složky objednávku uložit a ke kterému tématu ji přiřadit. Server hlavičku ověřuje proti evidenci témat.
(() => {
  const theme = getSiteTheme();
  if (!theme || typeof window.fetch !== 'function') return;
  const orig = window.fetch.bind(window);
  window.fetch = (input: RequestInfo | URL, init?: RequestInit) => {
    try {
      const raw = typeof input === 'string' ? input : input instanceof URL ? input.href : input.url;
      const url = new URL(raw, window.location.href);
      if (url.origin === window.location.origin && url.pathname.startsWith('/api/')) {
        const headers = new Headers(init?.headers ?? (input instanceof Request ? input.headers : undefined));
        if (!headers.has('X-Sticker-Theme')) headers.set('X-Sticker-Theme', theme.slug);
        return orig(input, { ...init, headers });
      }
    } catch { /* necháme volání beze změny */ }
    return orig(input, init);
  };
})();

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

const root = ReactDOM.createRoot(rootElement);

console.log("Starting School Sticker Creator Application...");

// Register Service Worker for PWA support — production only. Its cache-first
// strategy is exactly wrong for dev: it would keep serving an old bundle over
// Vite's live-reloaded source. In dev, actively unregister any SW left over
// from a previous production build served on this origin, so it can't shadow
// current edits with a stale cached bundle.
if ('serviceWorker' in navigator) {
  if (import.meta.env.PROD) {
    window.addEventListener('load', () => {
      navigator.serviceWorker.register('/sw.js').then(registration => {
        console.log('SW registered: ', registration);
      }).catch(registrationError => {
        console.log('SW registration failed: ', registrationError);
      });
    });
  } else {
    navigator.serviceWorker.getRegistrations().then(registrations => {
      registrations.forEach(registration => registration.unregister());
    });
  }
}

// Render the main application, wrapped in StrictMode for development checks
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
